import { PalletStateType } from "store/production.reducer"

export const COMPANY_NAME = "Sahyadri Farms Post Harvest Care Limited."
export const COMPANY_ADDRESS =
  "Gat No.: 314/1, 314/2/1, A/p: Mohadi, Taluka: Dindori, Nashik - 422207, Maharashtra, India."
export const COUNTRY = "INDIA"
export const PRODUCT_NAME = "Table Grapes"
export const GRADE_CLASS = "I"

export function getPackType(production: any): string {
  const capacity = production?.shipmentPlan?.skuType?.name
  return capacity ? capacity : "--"
}

export function getVariety(pallet: PalletStateType): string {
  const varieties = [
    ...new Set(pallet?.mhCodes?.map(m => m.variety).filter(Boolean)),
  ]
  return varieties.join(", ") || "--"
}

export function getProductName(pallet: PalletStateType): string {
  const names = [
    ...new Set(pallet?.mhCodes?.map(m => m.commodityName).filter(Boolean)),
  ]
  return names.join(", ") || "--"
}

export function getFarmRegNos(pallet: PalletStateType): string {
  const mhs = pallet?.mhCodes ?? []
  const farmNos = [...new Set(mhs.map(m => m.mhCode).filter(Boolean))]
  return farmNos.join(", ") || "--"
}

export function getLotCode(pallet: PalletStateType): string {
  return pallet?.lotCode?.[0]?.lotCode ?? "--"
}

export function getLotCodes(pallet: PalletStateType): string[] {
  return (pallet?.lotCode ?? []).map(l => l.lotCode).filter(Boolean) as string[]
}

export function getFarmRegNosArray(pallet: PalletStateType): string[] {
  const mhs = pallet?.mhCodes ?? []
  return [...new Set(mhs.map(m => m.mhCode).filter(Boolean))] as string[]
}

export function getGGN(production: any, pallet?: PalletStateType): string {
  try {
    const ggns = new Set<string>()

    if (pallet && production?.productionitemSet) {
      const prodItem = production.productionitemSet.find(
        (pi: any) => pi.palletNo === pallet.palletNumber
      )

      if (prodItem?.linetradeprofileSet) {
        prodItem.linetradeprofileSet.forEach((ltp: any) => {
          const documents =
            ltp?.approvedTradeProfile?.tradeProfile?.plotCommodity?.plot?.farmer
              ?.documents ?? []

          documents.forEach((doc: any) => {
            const certCodename = (
              doc?.certificationType?.codename || ""
            ).toLowerCase()

            // Identify if this is a GGN document
            if (certCodename.includes("ggn")) {
              if (doc.idNumber) ggns.add(doc.idNumber)
            }
          })
        })
      }
    }

    if (ggns.size > 0) {
      return [...ggns].join(", ")
    }

    // Fallback to metadata
    const meta = production?.shipmentPlan?.metadata
      ? JSON.parse(production.shipmentPlan.metadata)
      : {}
    return meta.ggn ?? "--"
  } catch {
    return "--"
  }
}

export function getSSCC(pallet: PalletStateType): string {
  return (pallet as any)?.sscc ?? "--"
}

export function getNetWeight(
  production: any,
  pallet?: PalletStateType
): string {
  const capacity = production?.shipmentPlan?.skuType?.capacity
  const skuType = production?.shipmentPlan?.skuType?.capacityUnit?.codename

  if (!capacity) return "--"

  if (pallet) {
    // Adding Packaging Material Calcultaions
    // const totalBoxes = Math.round(pallet.boxCount ?? 0)
    return `${capacity} ${skuType}`
  }

  return `${capacity} ${skuType}`
}

export function getSize(production: any): string {
  return production?.shipmentPlan?.size ?? "--"
}

export function getTotalBoxes(pallet: PalletStateType): number {
  return Math.round(pallet?.boxCount ?? 0)
}

export function getTotalKgs(pallet: PalletStateType): number {
  return Math.round(pallet?.weightCount ?? 0)
}
